import { render, staticRenderFns } from "./ListDuplicate.vue?vue&type=template&id=134f0ad2&scoped=true&"
import script from "./ListDuplicate.vue?vue&type=script&lang=js&"
export * from "./ListDuplicate.vue?vue&type=script&lang=js&"
import style0 from "./ListDuplicate.vue?vue&type=style&index=0&id=134f0ad2&scoped=true&lang=css&"
import style1 from "./ListDuplicate.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134f0ad2",
  null
  
)

export default component.exports